import type {NamedSetState} from 'app/gemStore/devtools';

import {
    addStickyStackItemToState,
    recalculateStickyStackHeightInState,
    removeStickyStackItemFromState,
    setStickyStackItemActiveInState,
    setStickyStackVisibleOnlyInState,
} from './actionHelpers';
import type {AddStickyStackItemParams, SetStickyStackItemActiveParams, SetStickyStackVisibleOnlyParams, StickyStackSlice} from './types';

export const createStickyStackSlice = (set: NamedSetState<StickyStackSlice>, get: () => StickyStackSlice) => ({
    stickyStack: [],
    addStickyStackItem: ({cId, stickyType, height}: AddStickyStackItemParams) => {
        set({stickyStack: addStickyStackItemToState(get().stickyStack, {cId, stickyType, height})}, false, 'stickyStack/addStickyStackItem');
    },
    removeStickyStackItem: (cId: string) => {
        set({stickyStack: removeStickyStackItemFromState(get().stickyStack, cId)}, false, 'stickyStack/removeStickyStackItem');
    },
    setStickyStackItemActive: ({cId, active}: SetStickyStackItemActiveParams) => {
        set({stickyStack: setStickyStackItemActiveInState(get().stickyStack, {cId, active})}, false, 'stickyStack/setStickyStackItemActive');
    },
    setStickyStackVisibleOnly: ({cId, visible}: SetStickyStackVisibleOnlyParams) => {
        set({stickyStack: setStickyStackVisibleOnlyInState(get().stickyStack, {cId, visible})}, false, 'stickyStack/setStickyStackVisibleOnly');
    },
    recalculateStickyStackHeight: () => {
        set({stickyStack: recalculateStickyStackHeightInState(get().stickyStack)}, false, 'stickyStack/recalculateStickyStackHeight');
    },
});
